import * as React from 'react';
import { SelectInput } from '../Select';
import { DurationProps } from '../../../../pages/partials/types';
import { HsField } from '../../hs_formik/Field';

export const DurationInDaysName: string = 'duration_in_days';
export const DurationThreeDays = '3';
export const DurationFiveDays = '5';
export const DurationOneWeekInDays = '7';
export const DurationTwoWeekInDays = '14';
export const DurationThreeWeekInDays = '21';
export const DurationFourWeekInDays = '28';

export const Duration = ({ options, modifier, disabled }: DurationProps): JSX.Element => {
    return (
        <HsField
            component={SelectInput}
            name={DurationInDaysName}
            options={options}
            modifier={modifier}
            disabled={disabled}
        />
    );
};
